import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { theme } from '../../../../shared/styles';
import { IBookingSummarySubmitProps } from '../shared/summary/IBookingSummarySubmitProps';
import { useDetailsFormContext } from './hooks/useDetailsFormContext';
import { ButtonWithLoader } from '../../../../../ui/components/Button/ButtonWithLoader';

export const DetailsSummarySubmitButton = ({
	shouldProceedWithoutPay,
}: IBookingSummarySubmitProps) => {
	const { t } = useTranslation();
	const {
		formState: { isSubmitting },
	} = useDetailsFormContext();
	const submitLabel = shouldProceedWithoutPay
		? t('web_booking_details_summary_submit_proceed')
		: t('web_booking_details_summary_submit');

	return (
		<StyledSubmitButton type="submit" isLoading={isSubmitting}>
			{submitLabel}
		</StyledSubmitButton>
	);
};

const StyledSubmitButton = styled(ButtonWithLoader)`
	justify-content: center;
	font-family: inherit;
	padding: 14px 16px;
	border-radius: 4px;
	box-shadow: 0px -3px 0px 0px #005b99 inset;
	outline: none;

	&:focus-visible {
		outline: ${theme.button?.primary?.focus?.outline};
	}
`;
